import CustomButtonSimple from "./CustomMiscellaneous/CustomButtonSimple"

type ButtonRowInput = {
    buttons: any;
    className?: string;
}

export function ButtonRow({ buttons, className }: ButtonRowInput) {


    return (


            <div className={`flex w-full justify-end ${className}`}>
                
                {buttons.map((button: any) => {
                    return (<div className="p-2 pb-0">
                            <CustomButtonSimple text={button.text} color={button.color} onClick={button.onClick} Icon={button.icon} className={button.className}/>
                        </div>)
                })}

            </div>
       

    )



}